exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html {\n  font-size: 62.5%;\n}\nbody {\n  font-family: \"Microsoft YaHei\" ! important;\n  -moz-user-select: none;\n  /*火狐*/\n  -webkit-user-select: none;\n  /*webkit浏览器*/\n  -ms-user-select: none;\n  /*IE10*/\n  -khtml-user-select: none;\n  /*早期浏览器*/\n  user-select: none;\n  font-size: 2.5rem;\n  margin: auto;\n}\na:link {\n  text-decoration: none;\n  color: white;\n}\na:visited {\n  text-decoration: none;\n  color: white;\n}\na:hover {\n  text-decoration: none;\n  color: white;\n}\na:active {\n  text-decoration: none;\n  color: white;\n}\na {\n  cursor: pointer;\n  color: white;\n}\n.jss-transparent {\n  background-color: rgba(255, 255, 255, 0.15);\n  /* IE9、标准浏览器、IE6和部分IE7内核的浏览器(如QQ浏览器)会读懂 */\n}\n.module_title {\n  font-size: 30px;\n  font-weight: bolder;\n}\n.money {\n  color: red;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./src/assets/css/index.less
// module id = uuxJ
// module chunks = 1